import script from "./checkDetail.vue?vue&type=script&lang=ts&setup=true"
export * from "./checkDetail.vue?vue&type=script&lang=ts&setup=true"

import "./checkDetail.vue?vue&type=style&index=0&id=03a119c3&lang=scss&scoped=true"

import exportComponent from "/builds/gh_prod_devops/gh_prod_devops_web/lpoa_prod_deploy/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-03a119c3"]])

export default __exports__